<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 维保模板配置
        </span>
        <div class="w_normalNav" :parent="self">
          <!-- <button class="BlueSmBtn" @click="subSeefrom">搜索</button> -->
          <!-- <button class="OrangeSmBtn" @click="reset">重置</button> -->
          <button class="GreenSmBtn" @click="addnew">新增</button>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" v-for="({prop,label,align}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">查看</el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-link>
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage"></el-pagination>
          </div>
        </div>
        <addModal v-model="commandDialog" :status="addStatus" :data="detailData" @refresh="getTableData"></addModal>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: '',
      tabName: 'jsgl',
      commandDialog: false,
      addStatus: '',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      detailData: {},
      companyType: localStorage.getItem('companyType')
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      if (this.companyType == 3) {
        return [
          {
            prop: 'create_time',
            label: '创建时间'
          },
          {
            prop: 'name',
            label: '模板名称'
          },
          {
            prop: 'type',
            label: '模板类型'
          },
          {
            prop: 'version',
            label: '版本/备注'
          }
        ]
      } else {
        return [
          {
            prop: 'create_time',
            label: '创建时间'
          },
          {
            prop: 'name',
            label: '模板名称'
          },
          {
            prop: 'type',
            label: '模板类型'
          },
          {
            prop: 'buildType',
            label: '楼宇类型'
          },
          {
            prop: 'version',
            label: '版本/备注'
          }
        ]
      }
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    addModal: () => import('./modal')
  },
  methods: {
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    //查询表格数据
    getTableData() {
      this.$axiosget('extra/maintenanceTemplate', {
        params: {
          pageSize: 10,
          pageNum: this.currentPage
        }
      }).then((res) => {
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    //新增
    addnew() {
      this.addStatus = 'adding'
      this.commandDialog = true
    },
    check(index, row) {
      this.detailData = row
      this.addStatus = 'readonly'
      this.commandDialog = true
    },
    edit(index, row) {
      let data = _.cloneDeep(row)
      this.detailData = data
      this.addStatus = 'editing'
      this.commandDialog = true
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('extra/maintenanceTemplate', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status === 10000) {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/wbTemplate/index.vue